import React from "react";

function DeFiDevServiceXeer() {
  return (
    <div className="about-area pt-5 pb-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 text-center">
            <div className="thumb pe-lg-5">
              <img
                src="/assets/img/about/1.jpg" // placeholder photograph
                alt="DeFi Development Service"
                style={{
                  maxWidth: "100%",
                  borderRadius: "10px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className=" mt-4 mt-lg-0">
              <h2
                className="title split-lines mb-4"
                style={{ fontWeight: "bold" }}
              >
                DeFi Development Service by Xeer Technology
              </h2>
              <p style={{ fontSize: "16px", color: "#555", lineHeight: "1.8" }}>
                At Xeer Technology, our premier blockchain veterans specialize
                in meticulously conceptualizing, engineering, and deploying
                highly automated, ultra-secure DeFi platforms securely. By
                closely auditing immense smart contract paradigms, we formulate
                exact foundational solutions spanning completely across diverse
                ecosystems encompassing decentralized exchanges, robust
                liquidity nodes, high-yield staking infrastructures, and highly
                functional Web3 payment solutions flawlessly tailored for your
                business evolution.
              </p>
              <div className="button mt-4">
                <a className="btn btn-style-one" href="#">
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeFiDevServiceXeer;
